import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from 'components/ErrorMessage';

const Input = ({
  type,
  testId,
  autoComplete,
  label,
  name,
  register,
  required,
  isDisabled,
  error,
  customError,
  className,
  ...rest
}) => {
  const hasError = !!(customError || error);
  return (
    <div className={className}>
      <label htmlFor={name} className="block mb-4 md:mb-2">
        <span className="label">{label}</span>
        <input
          {...register(name, { required })}
          autoComplete={autoComplete}
          id={name}
          type={type}
          data-testid={testId}
          className={`input input-full-border py-3 ${hasError ? 'error' : ''}`}
          disabled={isDisabled}
          {...rest}
        />
      </label>
      {hasError && (
        <ErrorMessage
          customMessage={customError}
          message={error}
          className="-mt-3 md:-mt-1"
        />
      )}
    </div>
  );
};

Input.propTypes = {
  testId: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  autoComplete: PropTypes.string,
  register: PropTypes.func,
  required: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.string,
  customError: PropTypes.node,
  className: PropTypes.string,
};
Input.defaultProps = {
  testId: 'input',
  type: 'text',
  label: '',
  name: 'input',
  autoComplete: 'new-password',
  required: false,
  register: () => null,
  isDisabled: false,
  error: null,
  className: '',
};

export default memo(Input);
